module.exports = __webpack_public_path__ + "static/media/wizualizacja-104.0237f3b3.png";